/**
 * This directive allows us to preselect ng-options in an angularized select box with numbers instead of strings.
 * A plain Javascript implementation is provided by the official AngularJS documentation at the bottom of
 * https://code.angularjs.org/1.5.3/docs/api/ng/directive/select
 */

export class ConvertToNumberDirective implements angular.IDirective {
    public require: string = 'ngModel';

    public link(scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) {
        ngModel.$parsers.push((val: any) => {
            return parseInt(val, 10);
        });

        ngModel.$formatters.push((val: any) => {
            return '' + val;
        });
    }

    public static Factory() {
        let directive = () => {
            return new ConvertToNumberDirective();
        };

        directive['$inject'] = [];

        return directive;
    }
}
